<template>
    <div
        class="slider"
        :class="[
            bindDefaultOptions.theme == 'black' ? 'black-theme' : 'white-theme'
        ]"
        v-bind="bindDefaultOptions"
    >
        <div class="mask">
            <div class="container">
                <div class="img">
                    <div class="backgroup-img">
                        <img class="inner-bg-img" :src="backgroupImg" />
                    </div>
                    <div class="inner-img">
                        <img :src="innerImg" />
                    </div>
                    <div class="move-img" :style="{ left: `${moveX}px` }">
                        <img class="inner-mv-img" :src="moveImg" />
                    </div>
                </div>
                <div class="slide">
                    {{ $t('message.common.puzzle') }}
                    <div
                        class="slider-mask"
                        :style="{ width: `${blcokLeft + 41}px` }"
                    >
                        <div
                            ref="block"
                            class="block"
                            :style="{ left: `${blcokLeft}px` }"
                            @mousedown="start"
                        >
                            <span class="yidun_slider_icon" />
                        </div>
                    </div>
                </div>
                <div v-if="loading" class="loading">
                    <span>loading...</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// =========================================
// 父组件需要提供的方法 名称
// =========================================

/**
 * 获取滑块图片方法
 */
// const GET_IMG_FUN = 'getImg'
/**
 * 校验滑块图片方法
 */
const VALID_IMG_FUN = 'validImg';
/**
 * 滑块窗口关闭事件监听
 */
const CLOST_EVENT_FUN = 'close';

export default {
    props: {
        // 是否开启日志， 默认true
        log: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            /** 滑块背景图片 */
            backgroupImg: '',
            /** 滑块缺失图片 */
            innerImg: '',
            /** 滑块图片 */
            moveImg: '',
            /** 是否已经移动滑块 */
            startMove: false,
            /** 滑块移动距离 */
            blcokLeft: 0,
            /** 开始滑动的x轴 */
            startX: 0,
            /** 划过的百分比 */
            movePercent: 0,
            /** 滑块移动的x轴 */
            moveX: 0,
            /** 加载遮罩标识 */
            loading: false,
            bindDefaultOptions: {
                theme: 'black'
            }
        };
    },
    mounted() {
        this.getImg();
    },
    /**
     * 销毁事件
     */
    beforeDestroy() {
        window.removeEventListener('mousemove', this.move);
        window.removeEventListener('mouseup', this.up);
    },
    methods: {
        /**
         * 打印日志
         */
        printLog(msg, ...optionalParams) {
            if (this.log) {
                if (optionalParams && optionalParams.length > 0) {
                    console.info(
                        `${this.$t('message.comC.sliderCaptcha')}[${msg}]`,
                        optionalParams.length === 1
                            ? optionalParams[0]
                            : optionalParams
                    );
                } else {
                    console.info(
                        `${this.$t('message.comC.sliderCaptcha')}[${msg}]`
                    );
                }
            }
        },

        /**
         * 获取滑块图片
         */
        getImg() {
            // this.loading = true
            this.backgroupImg = require('@/assets/user/safety_bg.png');
            this.moveImg = require('@/assets/user/slider.png');
            this.innerImg = require('@/assets/user/slider_black.png');
            //   this.$emit(GET_IMG_FUN, data => {
            //     this.printLog(GET_IMG_FUN, data)
            //     this.loading = false
            //     if (!data) return
            //     console.log('data', data)

            //     this.backgroupImg = data.captcha.backgroundImage
            //     this.moveImg = data.captcha.sliderImage
            //   })
        },
        /**
         * 校验图片
         */
        validImg() {
            this.printLog(this.$t('message.comC.sliderUp'), this.movePercent);
            console.log(this.movePercent);
            if (this.movePercent > 0.74 && this.movePercent < 0.77) {
                this.$emit(VALID_IMG_FUN, this.movePercent, data => {
                    this.printLog(VALID_IMG_FUN, data);
                    if (data === false) {
                        this.reset();
                    }
                });
            } else {
                this.reset();
            }
        },
        /**
         * 重新生成图片
         */
        reset() {
            this.getImg();
            this.moveX = 0;
            this.movePercent = 0;
            this.startX = 0;
            this.blcokLeft = 0;
        },
        /**
         * 按钮关闭事件
         */
        close() {
            this.printLog(this.$t('message.comC.closeButtonTrigger'));
            this.$emit(CLOST_EVENT_FUN);
        },
        /**
         * 开始滑动
         */
        start(e) {
            this.startX = e.pageX;
            this.startMove = true;
            window.addEventListener('mousemove', this.move);
            window.addEventListener('mouseup', this.up);
        },
        /**
         * 滑块滑动事件
         */
        move(e) {
            if (!this.startMove) return;
            const moveX = e.pageX - this.startX;
            const movePercent = moveX / 280;
            //   console.log(this.blcokLeft, moveX, movePercent)
            if (moveX <= 0) {
                this.blcokLeft = 0;
                this.moveX = 0;
                this.movePercent = 0;
            } else if (moveX >= 0 && moveX <= 391) {
                this.blcokLeft = moveX;
                this.moveX = moveX;
                this.movePercent = movePercent;
            } else if (moveX >= 391) {
                this.blcokLeft = 391;
                this.moveX = 391;
                this.movePercent = movePercent;
            }
        },
        /**
         * 滑块鼠标抬起事件
         */
        up(e) {
            window.removeEventListener('mousemove', this.move);
            window.removeEventListener('mouseup', this.up);
            if (!this.startMove) return;
            this.startMove = false;
            this.validImg();
        }
    }
};
</script>

<style lang="scss" scoped>
.slider-mask {
    position: absolute;
    left: 0;
    top: 0;
    height: 41px;
    border-radius: 21px;
    background-color: $basicColor;
}
.yidun_slider_icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('../../assets/user/slider_btn.png');
    background-position: center;
    background-size: cover;
}
.inner-mv-img,
.inner-bg-img,
.title {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
}
.slider {
    .mask {
        display: block;
        z-index: 998;
        background: rgba(0, 0, 0, 0);
        width: 310px;
        height: 306px;
    }
    .container {
        position: absolute;
        z-index: 999;
        width: 100%;
        height: 100%;
        margin: auto;
        background-color: #2b3139;
        // border-radius: 6px;
        box-sizing: border-box;
        padding: 20px 24px;
        .title {
            font-size: 14px;
            color: #333;
            display: flex;
            justify-content: space-between;
            .button-group {
                img {
                    width: 25px;
                    height: 25px;
                    cursor: pointer;
                }
            }
        }
        .img {
            width: 100%;
            height: 238px;
            position: relative;
            img {
                width: 100%;
            }
            .backgroup-img {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
            }
            .inner-img {
                width: 75px;
                position: absolute;
                top: 80px;
                left: 211px;
            }
            .move-img {
                width: 75px;
                position: absolute;
                left: 8px;
                top: 80px;
            }
        }
        .slide {
            width: 100%;
            height: 41px;
            background-color: #474d57;
            border-radius: 21px;
            box-sizing: border-box;
            position: relative;
            margin-top: 30px;

            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 12px;
            text-indent: 50px;
            font-weight: 500;
            color: #ffffff;
            font-family: 'PingFang_Regular';
            .block {
                width: 41px;
                height: 41px;
                position: absolute;
                left: 0;
                top: 0;
                cursor: pointer;
                border-radius: 50%;
            }
        }
        .block:hover {
            background-color: #1991fa;
        }
        .loading {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            position: absolute;
            top: 0;
            left: 0;
            border-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
        }
    }
}
.white-theme {
    .container {
        background-color: #ffffff;
        // .slide{
        //   background-color: #FFFFFF;
        //   &::before {
        //     color: #070707;
        //   }
        // }
    }
}
</style>
